(function jappsTickerInit() {
  document.querySelectorAll('.js-japps-usp-ticker').forEach(ticker => {
    ticker.classList.remove('japps-opacity-0');

    const track = ticker.querySelector('.js-japps-usp-track');
    const template = ticker.querySelector('.japps-usp-template');
    if (!track || !template) return;

    track.querySelectorAll('.js-japps-usp-content-clone').forEach(el => el.remove());

    requestAnimationFrame(() => {
      const width = template.getBoundingClientRect().width;

      if (width === 0) {
        // Try again shortly — likely not yet painted
        setTimeout(jappsTickerInit, 100);
        return;
      }

      const speed = parseFloat(ticker.dataset.speed || 40);
      const clones = Math.ceil((window.innerWidth * 2) / width);

      for (let i = 0; i < clones; i++) {
        const clone = template.cloneNode(true);
        clone.classList.remove('japps-usp-template');
        clone.classList.add('js-japps-usp-content-clone');
        track.appendChild(clone);
      }

      const scrollDistance = track.scrollWidth / 2;
      const duration = Math.max(speed, (speed / 1440) * window.innerWidth);

      const animation = track.animate(
        [
          { transform: 'translateX(0)' },
          { transform: `translateX(-${scrollDistance}px)` }
        ],
        {
          duration: duration * 1000,
          iterations: Infinity,
          easing: 'linear'
        }
      );

      if (window.matchMedia('(min-width: 1280px)').matches) {
        ticker.addEventListener('mouseenter', () => animation.pause());
        ticker.addEventListener('mouseleave', () => animation.play());
      }
    });
  });
})();
